import { katTranslator } from '../../shared/i18n';

const strings = {
  "defaultColumnLabel": {
    "en-US": "Column #{columnIndex}",
    "ar-AE": "العمود رقم {columnIndex}",
    "bn-IN": "কলাম #{columnIndex}",
    "de-DE": "Spalte {columnIndex}",
    "en-AU": "Column no. {columnIndex}",
    "en-CA": "Column no. {columnIndex}",
    "en-SG": "Column no. {columnIndex}",
    "en-ZA": "Column no.{columnIndex}",
    "es-ES": "Columna n.º {columnIndex}",
    "es-MX": "N.° de columna{columnIndex}",
    "fr-BE": "Colonne n°{columnIndex}",
    "fr-FR": "Numéro de la colonne{columnIndex}",
    "gu-IN": "કોલમ #{columnIndex}",
    "hi-IN": "कॉलम #{columnIndex}",
    "it-IT": "Colonna n.{columnIndex}",
    "ja-JP": "列番号{columnIndex}",
    "kn-IN": "ಅಂಕಣ #{columnIndex}",
    "ko-KR": "#{columnIndex} 열",
    "ml-IN": "കോളം #{columnIndex}",
    "mr-IN": "स्तंभ #{columnIndex}",
    "nl-BE": "Kolom nr. {columnIndex}",
    "nl-NL": "Kolomnr. {columnIndex}",
    "pl-PL": "Kolumna {columnIndex}",
    "pt-BR": "Coluna nº {columnIndex}",
    "pt-PT": "N.º de Coluna {columnIndex}",
    "sv-SE": "Kolumnnummer {columnIndex}",
    "ta-IN": "நெடுவரிசை #{columnIndex}",
    "te-IN": "కాలమ్ #{columnIndex}",
    "th-TH": "คอลัมน์ #{columnIndex}",
    "tr-TR": "Sütun {columnIndex}",
    "vi-VN": "Cột số {columnIndex}",
    "zh-CN": "列号 {columnIndex}",
    "zh-TW": "第 {columnIndex} 欄"
  },
  "sortAscending": {
    "en-US": "ascending",
    "ar-AE": "تصاعديًا",
    "bn-IN": "মানের ঊর্ধ্বক্রমে",
    "de-DE": "Aufsteigend",
    "es-ES": "ascendente",
    "es-MX": "ascendente",
    "fr-BE": "croissant",
    "fr-FR": "croissant",
    "gu-IN": "ચડતા ક્રમમાં",
    "hi-IN": "बढ़ते क्रम में",
    "it-IT": "crescente",
    "ja-JP": "昇順",
    "kn-IN": "ಏರಿಕೆ ಕ್ರಮ",
    "ko-KR": "오름차순",
    "ml-IN": "ആരോഹണ ക്രമത്തിൽ",
    "mr-IN": "चढत्या क्रमाने",
    "nl-BE": "oplopend",
    "nl-NL": "oplopend",
    "pl-PL": "w kolejności rosnącej",
    "pt-BR": "crescente",
    "pt-PT": "ascendente",
    "sv-SE": "stigande",
    "ta-IN": "ஏறுவரிசை",
    "te-IN": "ఆరోహణ",
    "th-TH": "เรียงจากน้อยไปมาก",
    "tr-TR": "artan",
    "vi-VN": "tăng dần",
    "zh-CN": "升序",
    "zh-TW": "遞增"
  },
  "sortDescending": {
    "en-US": "descending",
    "ar-AE": "تنازليًا",
    "bn-IN": "মানের অধঃক্রমে",
    "de-DE": "Absteigend",
    "es-ES": "descendente",
    "es-MX": "descendente",
    "fr-BE": "décroissant",
    "fr-FR": "décroissant",
    "gu-IN": "ઉતરતા ક્રમમાં",
    "hi-IN": "घटते क्रम में",
    "it-IT": "decrescente",
    "ja-JP": "降順",
    "kn-IN": "ಇಳಿಕೆ ಕ್ರಮ",
    "ko-KR": "내림차순",
    "ml-IN": "അവരോഹണ ക്രമത്തിൽ",
    "mr-IN": "उतरत्या क्रमाने",
    "nl-BE": "aflopend",
    "nl-NL": "aflopend",
    "pl-PL": "w kolejności malejącej",
    "pt-BR": "decrescente",
    "pt-PT": "descendente",
    "sv-SE": "fallande",
    "ta-IN": "இறங்கு வரிசை",
    "te-IN": "అవరోహణ",
    "th-TH": "เรียงจากมากไปน้อย",
    "tr-TR": "azalan",
    "vi-VN": "giảm dần",
    "zh-CN": "降序",
    "zh-TW": "遞減"
  },
  "sortButtonLabelStart": {
    "en-US": "Sort {columnLabel}",
    "ar-AE": "فرز {columnLabel}",
    "bn-IN": "সাজান {columnLabel}",
    "de-DE": "Sortieren nach {columnLabel}",
    "es-ES": "Ordenar {columnLabel}",
    "es-MX": "Ordenar {columnLabel}",
    "fr-BE": "Trier {columnLabel}",
    "fr-FR": "Trier {columnLabel}",
    "gu-IN": "સૉર્ટ {columnLabel}",
    "hi-IN": "{columnLabel} को सॉर्ट करें",
    "it-IT": "Ordina {columnLabel}",
    "ja-JP": "並べ替え{columnLabel}",
    "kn-IN": "{columnLabel} ವಿಂಗಡಿಸಿ",
    "ko-KR": "{columnLabel} 정렬",
    "ml-IN": "{columnLabel} അടുക്കുക",
    "mr-IN": "{columnLabel} ची क्रमवारी लावा",
    "nl-BE": "Sorteer {columnLabel}",
    "nl-NL": "Sorteren {columnLabel}",
    "pl-PL": "Sortuj kolumnę {columnLabel}",
    "pt-BR": "Classificar {columnLabel}",
    "pt-PT": "Ordenar {columnLabel}",
    "sv-SE": "Sortera {columnLabel}",
    "ta-IN": "வரிசைப்படுத்து {columnLabel}",
    "te-IN": "క్రమబద్ధీకరించు {columnLabel}",
    "th-TH": "เรียงลำดับ{columnLabel}",
    "tr-TR": "Sırala: {columnLabel}",
    "vi-VN": "Sắp xếp {columnLabel}",
    "zh-CN": "排序 {columnLabel}",
    "zh-TW": "排序：{columnLabel}"
  },
  "sortButtonLabelToggle": {
    "en-US": "Sort {columnLabel} {direction}",
    "ar-AE": "فرز {columnLabel} {direction}",
    "bn-IN": "সাজান {columnLabel} {direction}",
    "de-DE": "{direction} sortieren nach {columnLabel}",
    "es-ES": "Ordenar {columnLabel} {direction}",
    "es-MX": "Ordenar {columnLabel} {direction}",
    "fr-BE": "Trier {columnLabel} {direction}",
    "fr-FR": "Trier {columnLabel} {direction}",
    "gu-IN": "સૉર્ટ {columnLabel} {direction}",
    "hi-IN": "{columnLabel} {direction} को सॉर्ट करें",
    "it-IT": "Ordina {columnLabel} {direction}",
    "ja-JP": "並べ替え{columnLabel}{direction}",
    "kn-IN": "{columnLabel} {direction} ವಿಂಗಡಿಸಿ",
    "ko-KR": "{columnLabel} {direction} 정렬",
    "ml-IN": "{columnLabel} {direction} അടുക്കുക",
    "mr-IN": "{columnLabel} {direction} ची क्रमवारी लावा",
    "nl-BE": "Sorteer {columnLabel} {direction}",
    "nl-NL": "Sorteren {columnLabel} {direction}",
    "pl-PL": "Sortuj kolumnę {columnLabel} {direction}",
    "pt-BR": "Classificar {columnLabel} {direction}",
    "pt-PT": "Ordenar {columnLabel} {direction}",
    "sv-SE": "Sortera {columnLabel} {direction}",
    "ta-IN": "வரிசைப்படுத்து {columnLabel} {direction}",
    "te-IN": "క్రమబద్ధీకరించు {columnLabel} {direction}",
    "th-TH": "เรียงลำดับ {columnLabel} {direction}",
    "tr-TR": "Sırala: {columnLabel} {direction}",
    "vi-VN": "Sắp xếp {columnLabel} {direction}",
    "zh-CN": "排序 {columnLabel} {direction}",
    "zh-TW": "排序：{columnLabel}{direction}"
  },
  "columnSortedMessage": {
    "en-US": "Sorted {columnLabel} {direction}",
    "ar-AE": "تم الفرز {columnLabel} {direction}",
    "bn-IN": "সাজানো হয়েছে {columnLabel} {direction}",
    "de-DE": "{direction} sortiert nach {columnLabel}",
    "es-ES": "Ordenada {columnLabel} {direction}",
    "es-MX": "Ordenado {columnLabel} {direction}",
    "fr-BE": "{columnLabel} {direction} triées",
    "fr-FR": "Trié {columnLabel} {direction}",
    "gu-IN": "સૉર્ટ કરેલ {columnLabel} {direction}",
    "hi-IN": "{columnLabel} {direction} को सॉर्ट किया गया",
    "it-IT": "Ordinato {columnLabel} {direction}",
    "ja-JP": "並べ替え済み{columnLabel}{direction}",
    "kn-IN": "{columnLabel}{direction} ವಿಂಗಡಿಸಲಾಗಿದೆ",
    "ko-KR": "{columnLabel} {direction} 정렬됨",
    "ml-IN": "അടുക്കിയ {columnLabel}{direction}",
    "mr-IN": "{columnLabel} {direction} ची क्रमवारी लावली",
    "nl-BE": "Gesorteerd {columnLabel} {direction}",
    "nl-NL": "Gesorteerd {columnLabel} {direction}",
    "pl-PL": "Kolumnę {columnLabel} posortowano {direction}",
    "pt-BR": "Classificado {columnLabel} {direction}",
    "pt-PT": "Ordenado {columnLabel} {direction}",
    "sv-SE": "Sorterade {columnLabel} {direction}",
    "ta-IN": "வரிசைப்படுத்தப்பட்டது {columnLabel} {direction}",
    "te-IN": "క్రమబద్ధీకరించబడింది{columnLabel}{direction}",
    "th-TH": "เรียงลำดับแล้ว {columnLabel} {direction}",
    "tr-TR": "Sıralanan: {columnLabel} {direction}",
    "vi-VN": "Đã sắp xếp {columnLabel} {direction}",
    "zh-CN": "已排序 {columnLabel} {direction}",
    "zh-TW": "已排序：{columnLabel}{direction}"
  },
  "selectAllCheckboxAllLabel": {
    "en-US": "All Rows Selected",
    "ar-AE": "تم تحديد كل الصفوف",
    "bn-IN": "সকল সারি নির্বাচন করা হয়েছে",
    "de-DE": "Alle Zeilen ausgewählt",
    "en-AU": "All rows selected",
    "en-CA": "All rows selected",
    "en-GB": "All rows selected",
    "en-SG": "All rows selected",
    "en-ZA": "All rows selected",
    "es-ES": "Todas las filas seleccionadas",
    "es-MX": "Todas las filas seleccionadas",
    "fr-BE": "Toutes les lignes sélectionnées",
    "fr-FR": "Toutes les lignes sélectionnées",
    "gu-IN": "તમામ પંક્તિ (રો) પસંદ કરવામાં આવી",
    "hi-IN": "सभी पंक्तियां चुनी गई",
    "it-IT": "Tutte le righe selezionate",
    "ja-JP": "すべての行を選択済み",
    "kn-IN": "ಎಲ್ಲಾ ಸಾಲುಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
    "ko-KR": "모든 행이 선택됨",
    "ml-IN": "എല്ലാ റോകളും തിരഞ്ഞെടുത്തു",
    "mr-IN": "सर्व पंक्ती निवडल्या",
    "nl-BE": "Alle rijen geselecteerd",
    "nl-NL": "Alle rijen geselecteerd",
    "pl-PL": "Wybrano wszystkie wiersze",
    "pt-BR": "Todas as linhas selecionadas",
    "pt-PT": "Todas as linhas selecionadas",
    "sv-SE": "Alla rader markerade",
    "ta-IN": "அனைத்து வரிசைகளும் தேர்ந்தெடுக்கப்பட்டன",
    "te-IN": "అన్ని వరుసలు ఎంచుకోబడ్డాయి",
    "th-TH": "มีการเลือกแถวทั้งหมดแล้ว",
    "tr-TR": "Seçilen tüm satırlar",
    "vi-VN": "Đã chọn tất cả các hàng",
    "zh-CN": "已选择所有行",
    "zh-TW": "已選取所有列"
  },
  "selectAllCheckboxSomeLabel": {
    "en-US": "Some Rows Selected",
    "ar-AE": "بعض الصفوف المحددة",
    "bn-IN": "কয়েকটি সারি নির্বাচন করা হয়েছে",
    "de-DE": "Einige Zeilen ausgewählt",
    "en-AU": "Some rows selected",
    "en-CA": "Some rows selected",
    "en-GB": "Some rows selected",
    "en-SG": "Some rows selected",
    "en-ZA": "Some rows selected",
    "es-ES": "Algunas filas seleccionadas",
    "es-MX": "Algunas filas seleccionadas",
    "fr-BE": "Quelques lignes sélectionnées",
    "fr-FR": "Certaines lignes sélectionnées",
    "gu-IN": "કેટલીક પંક્તિઓ પસંદ કરેલ છે",
    "hi-IN": "कुछ पंक्तियां चुनी गई",
    "it-IT": "Alcune righe selezionate",
    "ja-JP": "一部の行が選択されました",
    "kn-IN": "ಕೆಲವು ಸಾಲುಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
    "ko-KR": "일부 행이 선택됨",
    "ml-IN": "ചില റോകൾ തിരഞ്ഞെടുത്തു",
    "mr-IN": "काही पंक्ती निवडल्या",
    "nl-BE": "Enkele rijen geselecteerd",
    "nl-NL": "Enkele rijen geselecteerd",
    "pl-PL": "Wybrano niektóre wiersze",
    "pt-BR": "Algumas linhas selecionadas",
    "pt-PT": "Algumas Linhas Selecionadas",
    "sv-SE": "Vissa rader markerade",
    "ta-IN": "சில வரிசைகள் தேர்ந்தெடுக்கப்பட்டன",
    "te-IN": "కొన్ని వరుసలు ఎంచుకోబడ్డాయి",
    "th-TH": "มีการเลือกบางแถวแล้ว",
    "tr-TR": "Seçilen bazı satırlar",
    "vi-VN": "Đã chọn một số hàng",
    "zh-CN": "已选择某些行",
    "zh-TW": "已選取部分列"
  },
  "selectAllCheckboxNoneLabel": {
    "en-US": "No Rows Selected",
    "ar-AE": "لم يتم تحديد صفوف",
    "bn-IN": "কোন সারি নির্বাচন করা হয়নি",
    "de-DE": "Keine Zeile ausgewählt",
    "en-AU": "No rows selected",
    "en-CA": "No rows selected",
    "en-GB": "No rows selected",
    "en-SG": "No rows selected",
    "en-ZA": "No rows selected",
    "es-ES": "No hay filas seleccionadas",
    "es-MX": "No hay filas seleccionadas",
    "fr-BE": "Aucune ligne sélectionnée",
    "fr-FR": "Aucune ligne sélectionnée",
    "gu-IN": "કોઈ પંક્તિઓ પસંદ કરેલ નથી",
    "hi-IN": "कोई पंक्ति नहीं चुनी गई",
    "it-IT": "Nessuna riga selezionata",
    "ja-JP": "行が選択されていません",
    "kn-IN": "ಯಾವುದೇ ಸಾಲುಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿಲ್ಲ",
    "ko-KR": "선택한 행 없음",
    "ml-IN": "റോകളൊന്നും തിരഞ്ഞെടുത്തില്ല",
    "mr-IN": "कोणत्याही पंक्ती निवडल्या नाहीत",
    "nl-BE": "Geen rijen geselecteerd",
    "nl-NL": "Geen rijen geselecteerd",
    "pl-PL": "Nie wybrano żadnego wiersza",
    "pt-BR": "Nenhuma linha selecionada",
    "pt-PT": "Nenhuma linha selecionada",
    "sv-SE": "Inga rader markerade",
    "ta-IN": "வரிசைகள் தேர்ந்தெடுக்கப்படவில்லை",
    "te-IN": "వరుసలు ఎంచుకోబడలేదు",
    "th-TH": "ไม่มีแถวที่ถูกเลือก",
    "tr-TR": "Satır seçilmedi",
    "vi-VN": "Chưa chọn hàng nào",
    "zh-CN": "未选择任何行",
    "zh-TW": "未選取任何一列"
  },
  "rowSelectionColumnLabel": {
    "en-US": "Row Selection",
    "ar-AE": "اختيار الصف",
    "bn-IN": "সারি নির্বাচন",
    "de-DE": "Zeilenauswahl",
    "en-AU": "Row selection",
    "en-CA": "Row selection",
    "en-GB": "Row selection",
    "en-SG": "Row selection",
    "en-ZA": "Row selection",
    "es-ES": "Selección de filas",
    "es-MX": "Selección de fila",
    "fr-BE": "Sélection de ligne",
    "fr-FR": "Sélection de ligne",
    "gu-IN": "પંક્તિ પસંદગી",
    "hi-IN": "पंक्ति का सेलेक्शन",
    "it-IT": "Selezione riga",
    "ja-JP": "行の選択",
    "kn-IN": "ಸಾಲಿನ ಆಯ್ಕೆ",
    "ko-KR": "행 선택",
    "ml-IN": "റോ തിരഞ്ഞെടുക്കൽ",
    "mr-IN": "पंक्तीची निवड",
    "nl-BE": "Rij selectie",
    "nl-NL": "Rij-selectie",
    "pl-PL": "Wybór wiersza",
    "pt-BR": "Seleção de linhas",
    "pt-PT": "Seleção da linha",
    "sv-SE": "Radval",
    "ta-IN": "வரிசை தேர்வு",
    "te-IN": "వరుస ఎంపిక",
    "th-TH": "การเลือกแถว",
    "tr-TR": "Satır seçimi",
    "vi-VN": "Lựa chọn hàng",
    "zh-CN": "行选择",
    "zh-TW": "選取列"
  },
  "rowCheckboxLabel": {
    "en-US": "Select Row #{rowIndex}",
    "ar-AE": "حدد الصف رقم {rowIndex}",
    "bn-IN": "সারি নির্বাচন করুন #{rowIndex}",
    "de-DE": "Zeile {rowIndex} auswählen",
    "en-AU": "Select row no. {rowIndex}",
    "en-CA": "Select row no. {rowIndex}",
    "en-GB": "Select row #{rowIndex}",
    "en-SG": "Select row no. {rowIndex}",
    "en-ZA": "Select row no.{rowIndex}",
    "es-ES": "Selecciona la fila n.º {rowIndex}",
    "es-MX": "Seleccionar n.° de fila{rowIndex}",
    "fr-BE": "Sélectionner la ligne n° {rowIndex}",
    "fr-FR": "Sélectionner un numéro de ligne{rowIndex}",
    "gu-IN": "પંક્તિ #{rowIndex} પસંદ કરો",
    "hi-IN": "पंक्ति #{rowIndex} चुनें",
    "it-IT": "Seleziona riga n.{rowIndex}",
    "ja-JP": "行番号{rowIndex}を選択",
    "kn-IN": "# {rowIndex} ಸಾಲು ಆಯ್ಕೆಮಾಡಿ",
    "ko-KR": "#{rowIndex} 행 선택",
    "ml-IN": "റോ #{rowIndex} തിരഞ്ഞെടുക്കുക",
    "mr-IN": "पंक्ती #{rowIndex} निवडा",
    "nl-BE": "Rij nr. {rowIndex} selecteren",
    "nl-NL": "Rijnr. selecteren{rowIndex}",
    "pl-PL": "Wybierz wiersz {rowIndex}",
    "pt-BR": "Selecionar linha nº {rowIndex}",
    "pt-PT": "Selecionar n.º de Linha {rowIndex}",
    "sv-SE": "Välj radnummer {rowIndex}",
    "ta-IN": "வரிசை #{rowIndex} ஐத் தேர்ந்தெடுக்கவும்",
    "te-IN": "వరుస #{rowIndex} ఎంచుకోండి",
    "th-TH": "เลือกแถว #{rowIndex}",
    "tr-TR": "{rowIndex} numaralı satırı seçin",
    "vi-VN": "Chọn hàng số {rowIndex}",
    "zh-CN": "选择行号 {rowIndex}",
    "zh-TW": "選取第 {rowIndex} 列"
  }
}; 

export default katTranslator(strings);
    